import type { Lang, LevelId, LocalizedText } from "@/math";
import { lang } from "@/state/store";

const dict = {
  pl: {
    "title.tagline": "Potwory z błędów zrani tylko poprawna odpowiedź.",
    "start.name": "Imię bohatera",
    "start.level": "Klasa",
    "start.language": "Język",
    "start.new": "Nowa gra",
    "start.continue": "Kontynuuj",
    "start.soon": "wkrótce",
    "start.hint":
      "Sterowanie: strzałki lub WASD – ruch, E lub spacja – rozmowa, I – plecak, 1–4 lub Enter – odpowiedź, H – podpowiedź, Esc – ucieczka, F1 – pomoc.",
    "start.answerMode": "Odpowiedzi",
    "start.answerMode.auto": "domyślnie dla klasy",
    "start.answerMode.choice": "przyciski (4 odpowiedzi)",
    "start.answerMode.typed": "wpisywanie",
    "start.timer": "Czas na odpowiedź",
    "start.timer.off": "bez limitu",
    "level.sp": "Szkoła podstawowa, klasa {n}",
    "level.lo": "Liceum, klasa {n}",
    "hud.lv": "Poz.",
    "hud.gold": "monet",
    "hud.potions": "mikstury",
    "hud.streak": "seria",
    "hud.xp": "PD",
    "hud.backpack": "Plecak (I)",
    "dialog.next": "Dalej",
    "dialog.close": "Zamknij",
    "world.interact": "E / spacja",
    "world.chest": "Skrzynia: +{gold} monet i mikstura!",
    "world.chestEmpty": "Skrzynia jest pusta.",
    "world.bridgeRepaired": "Most został naprawiony! Droga na wschód jest otwarta.",
    "sign.junction": "← Countinghollow: dom Starszej Abacji, sklep Milo   |   Most i łąki →",
    "sign.bridge.broken":
      "MOST ZERWANY. Brakuje desek — chochliki uciekły z nimi nad rzekę. Kupiec Milo szuka pomocy.",
    "sign.bridge.fixed": "Most naprawiony. Za rzeką grasują potwory — uważaj przy stawie!",
    "sign.title": "Drogowskaz",
    "sign.fire": "Ognisko Countinghollow. Wieczorami Starsza Abacja opowiada tu o Wielkiej Księdze.",
    "sign.south":
      "↑ Countinghollow   |   ↓ Ruiny Starej Rachuby i Kopalnia Koralików. Skryba Tomik szuka pomocy.",
    "sign.forest": "→ Szepczący Las: chata gajowego Borysa przy ścieżce. Trzymaj się ścieżki!",
    "sign.coast": "↓ Wybrzeże Konserw. Blaszany Legion patroluje plażę — kapitan Mila pilnuje drogi.",
    "sign.bridge2": "Południowy most. ← Kopalnia Koralików   |   Wybrzeże Konserw →",
    "sign.mine": "KOPALNIA KORALIKÓW — ZAMKNIĘTA. W środku krety. Kilof też. — Kazik",
    "sign.forestcoast": "↑ Szepczący Las   |   ↓ Plaża i chata rybaczki Marty",
    "sign.ruins": "Ruiny Starej Rachuby. Tu liczono wszystko, aż liczby się skończyły.",
    "battle.time": "czas",
    "battle.answer": "Odpowiedz",
    "battle.typeAnswer": "Wpisz odpowiedź…",
    "battle.usePotion": "Mikstura +{n} HP ({left})",
    "battle.hint": "Podpowiedź",
    "battle.hintFree": "(darmowa)",
    "battle.hintScroll": "(zwoje: {n})",
    "battle.correct": "Trafienie!",
    "battle.wrong": "Pudło!",
    "battle.timeout": "Czas minął!",
    "battle.quick": "Szybki cios ×1,5",
    "battle.critical": "Cios krytyczny ×2!",
    "battle.monsterHits": "{m} atakuje: −{n} HP",
    "battle.youHit": "Zadajesz {n} obrażeń",
    "battle.correctWas": "Poprawna odpowiedź: {a}",
    "battle.howTo": "Jak to policzyć:",
    "battle.continue": "Dalej",
    "battle.potionUsed": "Wypijasz miksturę: +{n} HP",
    "battle.won": "Zwycięstwo!",
    "battle.lost": "Bohater pada…",
    "battle.rewards": "+{xp} PD, +{gold} monet",
    "battle.levelUp": "Nowy poziom: {lvl}! Pełne zdrowie.",
    "battle.lostInfo": "Budzisz się w wiosce z pełnym zdrowiem. Tracisz {gold} monet.",
    "battle.back": "Wróć do świata",
    "battle.streak": "seria {n}",
    "battle.flee": "Uciekaj (−{gold} monet)",
    "battle.fledTitle": "Ucieczka!",
    "battle.fledInfo": "Uciekasz z walki. Potwór zostaje, a ty tracisz {gold} monet.",
    "training.title": "Trening z Magiem Kwilem",
    "training.intro": "Wybierz temat do ćwiczeń albo miks wszystkich tematów.",
    "training.mixed": "Wszystkie tematy",
    "training.difficulty": "Poziom",
    "training.tier.auto": "dopasuj",
    "training.tier.1": "łatwy",
    "training.tier.2": "średni",
    "training.tier.3": "trudny",
    "training.start": "Zaczynamy!",
    "training.score": "poprawne {correct}/{total}",
    "training.correct": "Świetnie!",
    "training.next": "Następne",
    "training.stop": "Zmień temat",
    "training.close": "Zamknij",
    "quest.accepted": "Nowe zadanie: {title}",
    "quest.progress": "{title}: {progress}/{count}",
    "quest.progressShort": "Postęp: {progress}/{count}",
    "quest.readyToTurnIn": "{title}: gotowe! Wróć do zleceniodawcy.",
    "quest.completed": "Zadanie ukończone: {title} (+{xp} PD, +{gold} monet)",
    "shop.title": "Sklep Kupca Milo",
    "shop.buy": "Kup",
    "shop.gold": "masz {gold} monet",
    "shop.bought": "Kupiono: {name}",
    "shop.tooExpensive": "Za mało monet!",
    "shop.close": "Zamknij (Esc)",
    "shop.owned": "masz {n}",
    "shop.moreAfterBridge": "Gdy most zostanie naprawiony, Milo sprowadzi broń i zbroje.",
    "start.avatar": "Bohater",
    "start.calculator": "Kalkulator w grze",
    "start.yes": "tak",
    "start.no": "nie",
    "start.curriculum": "Zakres materiału dla nauczyciela",
    "calc.title": "Kalkulator",
    "calc.use": "Wstaw wynik",
    "calc.close": "Zamknij (Esc)",
    "battle.calculator": "Kalkulator (K)",
    "training.hint": "Podpowiedź (H)",
    "training.keys": "↑↓←→ temat · +/− poziom · Enter start",
    "keys.list": "↑↓ wybór · Enter zatwierdź · Esc zamknij",
    "keys.tabs": "←→ zakładki · ↑↓ wybór · Enter zatwierdź · Esc zamknij",
    "backpack.report": "Raport dla nauczyciela",
    "backpack.curriculum": "Zakres materiału",
    "report.history.title": "Raport z wykonanych zadań",
    "report.curriculum.title": "Zakres materiału",
    "report.print": "Drukuj / zapisz jako PDF",
    "report.close": "Zamknij (Esc)",
    "report.noteNonEditable": "Dokument tylko do odczytu – wydrukuj lub zapisz jako PDF.",
    "report.generated": "Wygenerowano",
    "report.hero": "Uczeń",
    "report.level": "Poziom",
    "report.summary": "Podsumowanie",
    "report.answers": "Zadania",
    "report.correct": "Poprawne",
    "report.accuracy": "Skuteczność",
    "report.bestStreak": "Najdłuższa seria",
    "report.time": "Czas",
    "report.topic": "Temat",
    "report.attempts": "Liczba zadań",
    "report.avgTime": "Średni czas",
    "report.tasks": "Wszystkie zadania",
    "report.date": "Data",
    "report.question": "Zadanie",
    "report.answer": "Poprawna odpowiedź",
    "report.given": "Odpowiedź ucznia",
    "report.result": "Wynik",
    "report.context": "Tryb",
    "report.context.battle": "walka",
    "report.context.training": "trening",
    "report.code": "Kod weryfikacyjny",
    "report.codeInfo": "kod zależy od treści – każda zmiana danych zmienia kod.",
    "report.empty": "Brak zadań. Zagraj kilka walk lub trening z Magiem Kwilem.",
    "report.tier": "Poziom trudności",
    "report.curriculum.intro":
      "Poniżej znajdują się wszystkie tematy tego poziomu z przykładowymi zadaniami. Gra losuje zadania z tych schematów, więc liczby w grze będą inne.",
    "chest.title": "Strzeżona skrzynia",
    "chest.guarded": "Skrzyni strzeże {guard}. Chcesz walczyć o skarb?",
    "chest.fight": "Walcz!",
    "chest.leave": "Nie teraz",
    "chest.opened": "Skrzynia: {item}!",
    "chest.empty": "Ta skrzynia jest już pusta.",
    "backpack.title": "Plecak",
    "backpack.tab.equipment": "Ekwipunek",
    "backpack.tab.quests": "Zadania",
    "backpack.tab.progress": "Postępy",
    "backpack.slot.weapon": "Broń",
    "backpack.slot.armor": "Zbroja",
    "backpack.slot.accessory": "Dodatek",
    "backpack.empty": "pusto",
    "backpack.equip": "Załóż",
    "backpack.unequip": "Zdejmij",
    "backpack.use": "Użyj",
    "backpack.noItems": "Plecak jest pusty. Kup coś u Milo albo wykonaj zadanie.",
    "backpack.stats":
      "Atak +{atk} · Obrona +{def} · Czas na pytanie +{time} s · Darmowe podpowiedzi: {hints}",
    "backpack.noQuests": "Brak zadań. Porozmawiaj z mieszkańcami wioski.",
    "backpack.questDone": "ukończone",
    "backpack.questActive": "w toku",
    "backpack.close": "Zamknij (Esc)",
    "backpack.noProgress": "Zagraj kilka walk albo trening, a tu pojawią się statystyki.",
    "backpack.accuracy": "{pct}% ({correct}/{attempts})",
    "backpack.totals": "Odpowiedzi: {answered}, poprawne: {correct}, najdłuższa seria: {best}",
    "start.heroes": "Twoi bohaterowie",
    "start.newHero": "Nowy bohater",
    "start.play": "Graj",
    "start.delete": "Usuń bohatera",
    "start.confirmDelete": "Na pewno usunąć?",
    "start.cancel": "Anuluj",
    "start.lastPlayed": "ostatnio",
    "start.create": "Stwórz i graj",
    "start.back": "Wróć",
    "cloud.title": "Zapis w chmurze",
    "cloud.login": "Zaloguj się, aby grać na innych urządzeniach:",
    "cloud.loggedIn": "Zalogowano: {name}",
    "cloud.logout": "Wyloguj",
    "cloud.syncing": "Synchronizacja…",
    "cloud.synced": "Pobrano z chmury: {n}",
    "hud.menu": "Menu",
    "backpack.menu": "Zapisz i wyjdź do menu",
    "menu.saved": "Gra zapisana.",
    "help.title": "Jak grać",
    "help.tab.kid": "Dla gracza",
    "help.tab.adult": "Dla nauczyciela i rodzica",
    "help.close": "Zamknij (Esc)",
    "help.keys": "Klawisze",
    "help.foot": "←→ lub 1/2 – zakładki · ↑↓ – przewijanie · Esc – zamknij",
    "hud.help": "Pomoc (F1)",
    "hud.moreQuests": "+{n} · Zadania (Z)",
    "toolbar.backpack": "Plecak",
    "toolbar.backpack.title": "Plecak i ekwipunek (I)",
    "toolbar.quests": "Zadania",
    "toolbar.quests.title": "Lista zadań (Z)",
    "toolbar.progress": "Postępy",
    "toolbar.progress.title": "Postępy i raporty (P)",
    "toolbar.help": "Pomoc",
    "toolbar.help.title": "Jak grać (F1)",
    "toolbar.menu": "Menu",
    "start.help": "Jak grać? (F1)",
    "start.topics": "Tematy",
    "start.topics.allShort": "wszystkie tematy",
    "start.topics.all": "Wszystkie",
    "start.topics.none": "Żadne",
    "start.topics.choose": "Wybierz…",
    "start.topics.summary": "{n} z {total} tematów",
    "start.topics.hint":
      "Odznacz tematy, których jeszcze nie było w szkole, albo zostaw tylko te do powtórki. Potwory i trening „mieszany” pytają tylko z zaznaczonych. Zmienisz to później przyciskiem ⚙ przy bohaterze.",
    "start.topics.edit": "Tematy bohatera",
    "start.topics.save": "Zapisz tematy",
    "start.topics.saved": "Tematy zapisane: {name}",
    "cookie.text":
      "Ta gra zapisuje postępy w pamięci przeglądarki na tym urządzeniu. Jeśli się zalogujesz (Microsoft lub GitHub), używa też jednego ciasteczka logowania. Nie ma reklam ani śledzenia.",
    "cookie.ok": "Rozumiem",
  },
  en: {
    "title.tagline": "Monsters made of mistakes can only be hurt by correct answers.",
    "start.name": "Hero name",
    "start.level": "School level",
    "start.language": "Language",
    "start.new": "New game",
    "start.continue": "Continue",
    "start.soon": "coming soon",
    "start.hint":
      "Controls: arrows or WASD to move, E or Space to talk, I for backpack, 1–4 or Enter to answer, H for a hint, Esc to run away, F1 for help.",
    "start.answerMode": "Answers",
    "start.answerMode.auto": "level default",
    "start.answerMode.choice": "buttons (4 options)",
    "start.answerMode.typed": "typing",
    "start.timer": "Time per question",
    "start.timer.off": "no limit",
    "level.sp": "Elementary, grade {n}",
    "level.lo": "High school, year {n}",
    "hud.lv": "Lv",
    "hud.gold": "gold",
    "hud.potions": "potions",
    "hud.streak": "streak",
    "hud.xp": "XP",
    "hud.backpack": "Backpack (I)",
    "dialog.next": "Next",
    "dialog.close": "Close",
    "world.interact": "E / Space",
    "world.chest": "Chest: +{gold} gold and a potion!",
    "world.chestEmpty": "The chest is empty.",
    "world.bridgeRepaired": "The bridge is repaired! The road east is open.",
    "sign.junction": "← Countinghollow: Elder Abacia, Milo's shop   |   Bridge and meadows →",
    "sign.bridge.broken":
      "BRIDGE OUT. Planks missing — the imps ran off with them along the river. Merchant Milo needs help.",
    "sign.bridge.fixed": "Bridge repaired. Monsters roam beyond the river — careful near the pond!",
    "sign.title": "Signpost",
    "sign.fire":
      "The Countinghollow campfire. In the evenings Elder Abacia tells stories of the Great Ledger here.",
    "sign.south":
      "↑ Countinghollow   |   ↓ Ruins of Old Reckoning and the Bead Mine. Scribe Tomik needs help.",
    "sign.forest": "→ Whispering Forest: Forester Borys's hut by the path. Stay on the path!",
    "sign.coast": "↓ Cannery Coast. The Tin Legion patrols the beach — Captain Mila guards the road.",
    "sign.bridge2": "Southern bridge. ← Bead Mine   |   Cannery Coast →",
    "sign.mine": "BEAD MINE — CLOSED. Moles inside. Pickaxe too. — Kazik",
    "sign.forestcoast": "↑ Whispering Forest   |   ↓ Beach and Fisher Marta's hut",
    "sign.ruins": "Ruins of Old Reckoning. Everything was counted here, until the numbers ran out.",
    "battle.time": "time",
    "battle.answer": "Answer",
    "battle.typeAnswer": "Type your answer…",
    "battle.usePotion": "Potion +{n} HP ({left})",
    "battle.hint": "Hint",
    "battle.hintFree": "(free)",
    "battle.hintScroll": "(scrolls: {n})",
    "battle.correct": "Hit!",
    "battle.wrong": "Miss!",
    "battle.timeout": "Time is up!",
    "battle.quick": "Quick Strike ×1.5",
    "battle.critical": "Critical ×2!",
    "battle.monsterHits": "{m} attacks: −{n} HP",
    "battle.youHit": "You deal {n} damage",
    "battle.correctWas": "Correct answer: {a}",
    "battle.howTo": "How to solve it:",
    "battle.continue": "Continue",
    "battle.potionUsed": "You drink a potion: +{n} HP",
    "battle.won": "Victory!",
    "battle.lost": "The hero faints…",
    "battle.rewards": "+{xp} XP, +{gold} gold",
    "battle.levelUp": "Level up: {lvl}! Full health.",
    "battle.lostInfo": "You wake up in the village at full health. You lose {gold} gold.",
    "battle.back": "Back to the world",
    "battle.streak": "streak {n}",
    "battle.flee": "Run away (−{gold} gold)",
    "battle.fledTitle": "Escaped!",
    "battle.fledInfo": "You run from the fight. The monster stays and you lose {gold} gold.",
    "training.title": "Training with Wizard Quill",
    "training.intro": "Pick a topic to practise, or a mix of all topics.",
    "training.mixed": "All topics",
    "training.difficulty": "Difficulty",
    "training.tier.auto": "adaptive",
    "training.tier.1": "easy",
    "training.tier.2": "medium",
    "training.tier.3": "hard",
    "training.start": "Let's go!",
    "training.score": "correct {correct}/{total}",
    "training.correct": "Great!",
    "training.next": "Next",
    "training.stop": "Change topic",
    "training.close": "Close",
    "quest.accepted": "New quest: {title}",
    "quest.progress": "{title}: {progress}/{count}",
    "quest.progressShort": "Progress: {progress}/{count}",
    "quest.readyToTurnIn": "{title}: done! Return to the quest giver.",
    "quest.completed": "Quest completed: {title} (+{xp} XP, +{gold} gold)",
    "shop.title": "Merchant Milo's shop",
    "shop.buy": "Buy",
    "shop.gold": "you have {gold} gold",
    "shop.bought": "Bought: {name}",
    "shop.tooExpensive": "Not enough gold!",
    "shop.close": "Close (Esc)",
    "shop.owned": "you have {n}",
    "shop.moreAfterBridge": "Once the bridge is repaired Milo will stock weapons and armour.",
    "start.avatar": "Hero",
    "start.calculator": "In-game calculator",
    "start.yes": "yes",
    "start.no": "no",
    "start.curriculum": "Curriculum overview for teachers",
    "calc.title": "Calculator",
    "calc.use": "Insert result",
    "calc.close": "Close (Esc)",
    "battle.calculator": "Calculator (K)",
    "training.hint": "Hint (H)",
    "training.keys": "↑↓←→ topic · +/− difficulty · Enter start",
    "keys.list": "↑↓ select · Enter confirm · Esc close",
    "keys.tabs": "←→ tabs · ↑↓ select · Enter confirm · Esc close",
    "backpack.report": "Teacher report",
    "backpack.curriculum": "Curriculum overview",
    "report.history.title": "Report of completed tasks",
    "report.curriculum.title": "Curriculum overview",
    "report.print": "Print / save as PDF",
    "report.close": "Close (Esc)",
    "report.noteNonEditable": "Read-only document – print it or save it as a PDF.",
    "report.generated": "Generated",
    "report.hero": "Student",
    "report.level": "Level",
    "report.summary": "Summary",
    "report.answers": "Tasks",
    "report.correct": "Correct",
    "report.accuracy": "Accuracy",
    "report.bestStreak": "Best streak",
    "report.time": "Time",
    "report.topic": "Topic",
    "report.attempts": "Tasks",
    "report.avgTime": "Average time",
    "report.tasks": "All tasks",
    "report.date": "Date",
    "report.question": "Task",
    "report.answer": "Correct answer",
    "report.given": "Student answer",
    "report.result": "Result",
    "report.context": "Mode",
    "report.context.battle": "battle",
    "report.context.training": "training",
    "report.code": "Verification code",
    "report.codeInfo": "the code depends on the content – any change to the data changes the code.",
    "report.empty": "No tasks yet. Play a few battles or train with Wizard Quill.",
    "report.tier": "Difficulty",
    "report.curriculum.intro":
      "Every topic of this level with example tasks. The game generates tasks from these patterns, so the numbers in the game will differ.",
    "chest.title": "Guarded chest",
    "chest.guarded": "The chest is guarded by {guard}. Do you want to fight for the treasure?",
    "chest.fight": "Fight!",
    "chest.leave": "Not now",
    "chest.opened": "Chest: {item}!",
    "chest.empty": "This chest is already empty.",
    "backpack.title": "Backpack",
    "backpack.tab.equipment": "Equipment",
    "backpack.tab.quests": "Quests",
    "backpack.tab.progress": "Progress",
    "backpack.slot.weapon": "Weapon",
    "backpack.slot.armor": "Armour",
    "backpack.slot.accessory": "Accessory",
    "backpack.empty": "empty",
    "backpack.equip": "Equip",
    "backpack.unequip": "Remove",
    "backpack.use": "Use",
    "backpack.noItems": "Your backpack is empty. Buy something from Milo or finish a quest.",
    "backpack.stats": "Attack +{atk} · Defence +{def} · Time per question +{time} s · Free hints: {hints}",
    "backpack.noQuests": "No quests yet. Talk to the villagers.",
    "backpack.questDone": "done",
    "backpack.questActive": "active",
    "backpack.close": "Close (Esc)",
    "backpack.noProgress": "Play a few battles or a training session and statistics will appear here.",
    "backpack.accuracy": "{pct}% ({correct}/{attempts})",
    "backpack.totals": "Answers: {answered}, correct: {correct}, best streak: {best}",
    "start.heroes": "Your heroes",
    "start.newHero": "New hero",
    "start.play": "Play",
    "start.delete": "Delete hero",
    "start.confirmDelete": "Really delete?",
    "start.cancel": "Cancel",
    "start.lastPlayed": "last played",
    "start.create": "Create and play",
    "start.back": "Back",
    "cloud.title": "Cloud save",
    "cloud.login": "Sign in to play on other devices:",
    "cloud.loggedIn": "Signed in: {name}",
    "cloud.logout": "Sign out",
    "cloud.syncing": "Syncing…",
    "cloud.synced": "Fetched from the cloud: {n}",
    "hud.menu": "Menu",
    "backpack.menu": "Save and exit to menu",
    "menu.saved": "Game saved.",
    "help.title": "How to play",
    "help.tab.kid": "For players",
    "help.tab.adult": "For teachers and parents",
    "help.close": "Close (Esc)",
    "help.keys": "Keys",
    "help.foot": "←→ or 1/2 – tabs · ↑↓ – scroll · Esc – close",
    "hud.help": "Help (F1)",
    "hud.moreQuests": "+{n} · Quests (Z)",
    "toolbar.backpack": "Backpack",
    "toolbar.backpack.title": "Backpack and equipment (I)",
    "toolbar.quests": "Quests",
    "toolbar.quests.title": "Quest list (Z)",
    "toolbar.progress": "Progress",
    "toolbar.progress.title": "Progress and reports (P)",
    "toolbar.help": "Help",
    "toolbar.help.title": "How to play (F1)",
    "toolbar.menu": "Menu",
    "start.help": "How to play? (F1)",
    "start.topics": "Topics",
    "start.topics.allShort": "all topics",
    "start.topics.all": "All",
    "start.topics.none": "None",
    "start.topics.choose": "Choose…",
    "start.topics.summary": "{n} of {total} topics",
    "start.topics.hint":
      "Untick topics the school has not covered yet, or keep only the ones to revise. Monsters and “mixed” training ask only from the ticked ones. Change it later with the ⚙ button next to the hero.",
    "start.topics.edit": "Hero's topics",
    "start.topics.save": "Save topics",
    "start.topics.saved": "Topics saved: {name}",
    "cookie.text":
      "This game stores progress in your browser on this device. If you sign in (Microsoft or GitHub) it also uses one login cookie. There are no ads and no tracking.",
    "cookie.ok": "Got it",
  },
} as const;

export type I18nKey = keyof typeof dict.pl;

export function t(
  key: I18nKey,
  params: Record<string, string | number> = {},
  language: Lang = lang.value,
): string {
  let s: string = dict[language][key] ?? dict.pl[key] ?? key;
  for (const [k, v] of Object.entries(params)) s = s.replaceAll(`{${k}}`, String(v));
  return s;
}

export function lt(text: LocalizedText, language: Lang = lang.value): string {
  return text[language];
}

export function levelLabel(level: LevelId, language: Lang = lang.value): string {
  const n = level.slice(2);
  return level.startsWith("sp") ? t("level.sp", { n }, language) : t("level.lo", { n }, language);
}
